import * as React from 'react';
import { Grid, GridToolbar, GridColumn as Column } from '@progress/kendo-react-grid';
import AnalyticComponentsService from "../../services/AnalyticComponents.service";
import { CustomListCommandCell } from "../../components/GridCustomListCommandCell";
import { GridCustomLoadingCell } from "../../components/GridCustomLoadingCell";
import { PanelCustomLoader } from "../../components/PanelCustomLoader";
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { avaiableLangList } from '../../i18nextConf'

export default function AnalyticalComponentList(props) {

    const { t } = useTranslation();
    const isAdmin = props.isAdmin;

    const CommandCell = props => (
        <CustomListCommandCell
            {...props}
            editField='inEdit'
            remove={remove}
            linkToDetails={'/AnalyticComponents/' + props.dataItem.analyticComponentId + '/Edit'}
            isAdmin={isAdmin}
        />
    );

    const [state, setState] = React.useState({ skip: 0, take: 10 });
    const [analyticComponents, setAnalyticComponents] = React.useState([]);
    const [results, setResults] = React.useState(0);
    const [loading, setLoading] = React.useState(true);
    const [sorting, setSorting] = React.useState(null);
    const [sortingBy, setSortingBy] = React.useState(null);

    React.useEffect(() => {

        setLoading(true);

        var selected = localStorage.getItem("i18nextLng") || "en";
        var selectedLangDetails = avaiableLangList.find(lang => lang.short === selected);

        if (sortingBy != null)
            AnalyticComponentsService.getAnalyticComponentsOrderBy(Math.ceil((state.skip + 1) / 10), state.take, sortingBy, selectedLangDetails.id)
                .then(response => response.data)
                .then(json => {
                    setAnalyticComponents(json.contract);
                    setResults(json.totalResults);
                    setLoading(false);
                });
        else
            AnalyticComponentsService.getAnalyticComponents(Math.ceil((state.skip + 1) / 10), state.take, selectedLangDetails.id)
                .then(response => response.data)
                .then(json => {
                    setAnalyticComponents(json.contract);
                    setResults(json.totalResults);
                    setLoading(false);
                });

    }, [state.skip, state.take, t, sortingBy]);

    const remove = (dataItem) => {
        console.log(dataItem);
        AnalyticComponentsService.deleteAnalyticComponent(dataItem).then(response => {

            if (response.status === 200)
                setState({ skip: state.skip, take: state.take });
        });

    }
    const sortChange = (event) => {

        if (event.sort.length === 0) {
            if (sorting != null) {

                setSorting(null);
                setSortingBy(null);
            }
        }
        else {
            setSorting(event.sort);
            setSortingBy(event.sort[0].field + " " + event.sort[0].dir);
        }

    }


    const pageChange = (event) => {
        setState({ skip: event.page.skip, take: event.page.take });
    }

    return (
        <div>
            { loading && PanelCustomLoader}

            <Grid
                data={analyticComponents}
                editField='inEdit'
                skip={state.skip}
                take={state.take}
                total={results}
                pageable={{ buttonCount: 4, pageSizes: [10, 20, 50, 100] }}
                scrollable={'none'}
                onPageChange={pageChange}
                cellRender={GridCustomLoadingCell}
                sort={sorting}
                sortable={{
                    allowUnsort: true,
                    mode: 'single'
                }}
                onSortChange={sortChange}
            >
                {isAdmin ? (<GridToolbar>
                    <div>
                        <Link to={'/AnalyticComponents/Add'}>
                            <button title={t("AnalyticComponentss_Button_Tooltip_New")} className="k-button k-primary">
                                &nbsp;<span className="k-icon k-i-plus-circle" />&nbsp; {t("Global_Button_Text_New")} &nbsp;
                        </button>
                        </Link>
                    </div>
                </GridToolbar>) : (<span />)}
                <Column cell={CommandCell} width={isAdmin ? ("160px") : ("80px")} sortable={false} />
                <Column field="analyticComponentId" title={t("AnalyticComponents_ID_Label")} width="100px" />
                <Column field="name" title={t("AnalyticComponents_Name_Label")} />
            </Grid>
        </div>
    );
}
